import { AppStateContextType } from './AppStateContextType'

let instance: AppStateContextType | null = null

export const setAppContextInstance = (ctx: AppStateContextType): void => {
  instance = ctx
}

export const getAppContextInstance = (): AppStateContextType => {
  if (!instance) {
    throw new Error('App context instance has not been initialized yet')
  }
  return instance
}
